import React from 'react';
import './RadioInput.pcss';
import classNames from 'classnames';

export type RadioInputProps = {
  label?: string | JSX.Element;
  className?: string;
  disabled?: boolean;
  children?: string | JSX.Element;
  css?: {
    input?: string;
    labelTitle?: string;
  };
} & React.InputHTMLAttributes<HTMLInputElement>;

const RadioInput = ({
  checked,
  value,
  onChange,
  label,
  className,
  disabled,
  name,
  onClick,
  readOnly,
  css,
  children,
  ...props
}: RadioInputProps) => {
  return (
    <div className={classNames(className, 'radio-input')}>
      <label className={classNames('radio-input-label', css?.input)}>
        <input
          type="radio"
          value={value}
          checked={checked}
          onChange={onChange}
          onClick={onClick}
          name={name}
          disabled={disabled}
          readOnly={readOnly}
          className={classNames(className, 'radio-input__input')}
          {...props}
        />
        {label && (
          <span
            className={classNames('radio-input-label__title', css?.labelTitle)}
            title={typeof label === 'string' ? label : ''}
          >
            {label}
          </span>
        )}
      </label>
      {children}
    </div>
  );
};

export default RadioInput;
